






































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import {
  Hooper,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
  Slide,
} from 'hooper';
import 'hooper/dist/hooper.css';
import { IGame } from '~/store/games/types';

const _debounce = require('lodash.debounce');

@Component({
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
  },
})
export default class InteractableBanner extends Vue {
  @State(games => games.games, { namespace: 'games' })
  games!: IGame[];
  @State(profile => profile.user.loggedIn, { namespace: 'profile' })
  loggedIn!: boolean;
  @State(cmsContent => cmsContent.carouselBanners, { namespace: 'cmsContent' })
  sanityBanners!: any[];

  @Action('promptToRegister')
  private promptToRegister!: (options?: {
    redirectAfterLoginPath?: string;
  }) => void;

  currentCarouselIndex = 0;
  taglineHeight = 0;
  carouselBannerHeight = 0;
  carouselBannerHeightInitialized = false;
  windowWidth = window ? window.innerWidth : 0;
  resizeIntervalSet = false;
  shouldShowNextSlide = false;
  updateElementsInterval = setInterval(this.updateCarouselBannerHeight, 100);
  debouncedUpdateCarousel = _debounce(() => {
    if (!this.resizeIntervalSet) {
      this.resizeIntervalSet = true;
      this.updateElementsInterval = setInterval(
        this.updateCarouselBannerHeight,
        400,
      );
      setTimeout(() => {
        clearInterval(this.updateElementsInterval);
        this.resizeIntervalSet = false;
      }, 4000);
    }
  }, 200);

  hooperSettings = {
    infiniteScroll: true,
    wheelControl: false,
    touchDrag: true,
    autoPlay: true,
    transition: 350,
    playSpeed: 4000,
  };

  get galaChainMigrationBanner() {
    return {
      title: this.$t(
        'components.home.interactiveBanner.galaChainMigrationBanner.title',
      ) as string,
      description: this.$t(
        'components.home.interactiveBanner.galaChainMigrationBanner.description',
      ) as string,
      tagline: this.$t(
        'components.home.interactiveBanner.galaChainMigrationBanner.tagline',
      ) as string,
      learnMoreText: this.$t(
        'components.home.interactiveBanner.galaChainMigrationBanner.learnMoreText',
      ) as string,
      learnMoreLink: 'https://gogalagames.medium.com/', // TODO: update this link with a real one when we get it
      playLink: '',
      bannerImage:
        'https://static.gala.games/images/interactiveHomeBanner/galachain_banner.jpg',
      bannerImageMin:
        'https://static.gala.games/images/interactiveHomeBanner/galachain_bannerM.jpg',
      bannerImageClass: '',
    };
  }

  get denseHero() {
    return this.$vuetify.breakpoint.xs;
  }

  get banners() {
    const sanityBannersToShow = this.sanityBanners.filter(
      b =>
        b.whenUnauthenticated == null ||
        b.whenUnauthenticated === !this.loggedIn,
    );

    return sanityBannersToShow.filter(Boolean);
  }

  setNextSlideVisibility() {
    this.shouldShowNextSlide = true;
  }

  mounted() {
    window.addEventListener('resize', this.setWindowWidth);
    window.addEventListener('resize', this.handleCarouselBannerHeight);
    this.setWindowWidth();
    this.updateCarouselBannerHeight();
  }

  updated() {
    this.updateTaglineHeight();
  }

  destroyed() {
    window.removeEventListener('resize', this.setWindowWidth);
    window.removeEventListener('resize', this.handleCarouselBannerHeight);
  }

  handleCarouselBannerHeight(event: any) {
    this.updateCarouselBannerHeight();
    this.debouncedUpdateCarousel();
  }

  setWindowWidth() {
    this.windowWidth = window.innerWidth;
  }

  updateTaglineHeight() {
    // Getting the height of the tagline paragraph allows us to size the yellow background correctly
    const taglineParagraph = this.$refs.tagline as Element;

    if (taglineParagraph) {
      this.taglineHeight = taglineParagraph.clientHeight;
    }
  }

  updateCarouselBannerHeight() {
    // Getting the height of the carousel banner allows us to always correctly position the carousel-content div relative to its height
    const carouselBanner = this.$refs.carouselBanner as Element;

    if (carouselBanner) {
      if (this.carouselBannerHeight === 0) {
        // This sets the initial clientHeight of the banner, before the game content gets loaded and the DOM updates
        this.carouselBannerHeight = carouselBanner.clientHeight;
      } else {
        const prevHeight = this.carouselBannerHeight;
        this.carouselBannerHeight = carouselBanner.clientHeight;
        // This runs once, as soon as the games initially load and update the DOM, at which point we have our correct starting height and no longer need the setInterval to run
        if (
          this.carouselBannerHeight > prevHeight &&
          !this.carouselBannerHeightInitialized
        ) {
          clearInterval(this.updateElementsInterval);
          this.carouselBannerHeightInitialized = true;
          this.updateElementsInterval = setInterval(
            this.updateCarouselBannerHeight,
            400,
          );

          setTimeout(() => {
            clearInterval(this.updateElementsInterval);
          }, 10000);
        }
      }
    }
  }

  // Allows us to sync text and buttons with the currently displayed carousel image.
  // Runs on initial carousel load as well as when carousel index is switched.
  updateCarouselIndex(event: any) {
    if (event.slideFrom !== null) {
      const lastBannerIndex = this.banners.length - 1;
      const isRight = event.currentSlide > event.slideFrom;
      if (Math.abs(event.currentSlide - event.slideFrom) > 1) {
        // When using the Hooper pagination buttons to navigate, the currentSlide number is always correct
        this.currentCarouselIndex = event.currentSlide;
      } else {
        // Hooper appears to have an issue where the currentSlide index is not always correct for the @slide event.
        // After the first loop through the slides, when looping forward it consistently
        // marks the item at 0 index as one index number higher than the last index in the banners array.
        // And when sliding backward it consistently marks the last index in the banner array as -1.
        // However, this code allows us to always track the current slide index correctly.
        if (isRight) {
          if (event.currentSlide > lastBannerIndex) {
            this.currentCarouselIndex = 0;
          } else {
            if (event.slideFrom < lastBannerIndex) {
              this.currentCarouselIndex++;
            } else {
              this.currentCarouselIndex = 0;
            }
          }
        } else {
          if (event.currentSlide < 0) {
            this.currentCarouselIndex = lastBannerIndex;
          } else {
            if (event.slideFrom > 0) {
              this.currentCarouselIndex--;
            } else {
              this.currentCarouselIndex = lastBannerIndex;
            }
          }
        }
      }
    }

    setTimeout(() => {
      this.shouldShowNextSlide = false;
    }, 800);

    if (event.slideFrom !== null) {
      setTimeout(() => {
        this.updateCarouselBannerHeight();
      }, 0);
    }
  }

  async validateAuthRequirement(gameRoute: string) {
    const gameToPlay = this.games.find(game => game.route === gameRoute);
    if (
      gameToPlay &&
      gameToPlay.requireAuthToPlay &&
      // @ts-ignore For some reason it does not know about the token property https://github.com/nuxt-community/auth-module/issues/1338
      !this.$auth.strategy.token.get()
    ) {
      if (this.loggedIn) {
        window.location.assign(
          `${window.location.origin}${this.$route.path}?register=1`,
        );
      } else {
        this.promptToRegister({ redirectAfterLoginPath: this.$route.fullPath });
      }
      return false;
    }
    return true;
  }

  async launchGame(gameRoute: string) {
    const passedAuthValidation = await this.validateAuthRequirement(gameRoute);
    if (!passedAuthValidation) {
      return;
    }

    if (process.env.displayGameInIframe) {
      if (document.body.requestFullscreen) {
        document.body.requestFullscreen();
      } else if ((document.body as any).webkitRequestFullscreen) {
        (document.body as any).webkitRequestFullscreen();
      }
    }

    this.$router.push(`/games/${gameRoute}/play`);
  }

  goTo(route: string) {
    if (route.startsWith('/')) {
      if (route.includes('/?register=1')) {
        this.promptToRegister({ redirectAfterLoginPath: this.$route.fullPath });
      } else {
        this.$router.push(route);
      }
    } else {
      window.open(route);
    }
  }
}
